var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.reservationMode)?_c('div',[_c('docomo-marker'),_c('my-spot-marker')],1):_c('div',[_c('destination-marker'),_c('spot-marker'),_c('google-place-marker'),_c('location-marker'),_c('my-spot-marker')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }